import React from 'react';
import { Button } from './ui/Button';
import { Star, Check } from 'lucide-react';
const URL_COMBO = 'https://www.compradigitalya.com/cart/42828918915143:1';
const URL_NEGOCIO = 'https://www.compradigitalya.com/cart/42828921372743:1';
export function PostTestimonialsOffer() {
  return <section className="py-12 md:py-16 px-4 max-w-5xl mx-auto" data-id="element-279">
      <div className="text-center mb-8 md:mb-10" data-id="element-280">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-281">
          🔥 Sumate a las que ya lo tienen
        </p>
        <h2 className="text-2xl md:text-4xl font-extrabold leading-tight max-w-3xl mx-auto" data-id="element-282">
          Elegí tu plan y{' '}
          <span className="text-primary" data-id="element-283">transformá tu cuerpo hoy</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-284">
        {/* OPTION 1 */}
        <div className="bg-surface border border-zinc-800 rounded-3xl p-6 md:p-8 flex flex-col" data-id="element-285">
          <div className="flex items-center gap-2 mb-2" data-id="element-286">
            <span className="text-3xl md:text-4xl" data-id="element-287">🍑</span>
            <h3 className="text-xl md:text-2xl font-extrabold" data-id="element-288">
              30 Días de Glúteos
            </h3>
          </div>
          <p className="text-zinc-400 text-sm mb-5" data-id="element-289">
            4 Tomos + Bono de Recetas
          </p>

          <ul className="space-y-2 mb-6 flex-grow" data-id="element-290">
            {['4 Tomos completos PDF', 'Bono Recetario 30 días', 'Garantía 7 días'].map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-291">
                <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" data-id="element-292" />
                <span className="text-zinc-200" data-id="element-293">{f}</span>
              </li>)}
          </ul>

          <div className="mb-5" data-id="element-294">
            <div className="text-zinc-500 line-through text-sm font-bold mb-1" data-id="element-295">
              $51.000
            </div>
            <div className="text-3xl md:text-4xl font-extrabold text-white" data-id="element-296">
              $19.990
            </div>
          </div>

          <Button href={URL_COMBO} fullWidth className="py-3.5 text-base" data-id="element-297">
            👉 QUIERO MIS 4 TOMOS
          </Button>
        </div>

        {/* OPTION 2 — RECOMMENDED */}
        <div className="relative bg-surface border-2 border-primary rounded-3xl p-6 md:p-8 flex flex-col shadow-[0_0_40px_rgba(249,168,212,0.2)]" data-id="element-298">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-black font-extrabold px-4 py-1 rounded-full text-xs md:text-sm flex items-center gap-1 whitespace-nowrap shadow-[0_0_15px_rgba(249,168,212,0.6)]" data-id="element-299">
            <Star className="w-3.5 h-3.5 fill-black" data-id="element-300" /> MÁS ELEGIDO
          </div>

          <div className="flex items-center gap-2 mb-2" data-id="element-301">
            <span className="text-3xl md:text-4xl" data-id="element-302">🔥</span>
            <h3 className="text-xl md:text-2xl font-extrabold" data-id="element-303">Plan Total</h3>
          </div>
          <p className="text-primary text-sm font-medium mb-5" data-id="element-304">
            4 Tomos + Bono + Seguimiento
          </p>

          <ul className="space-y-2 mb-6 flex-grow" data-id="element-305">
            {['TODO el plan base incluido', 'Trackers imprimibles extra', 'Guía post-30 días incluida', 'Garantía 7 días'].map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-306">
                <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" data-id="element-307" />
                <span className="text-white font-medium" data-id="element-308">{f}</span>
              </li>)}
          </ul>

          <div className="mb-5" data-id="element-309">
            <div className="text-zinc-500 line-through text-sm font-bold mb-1" data-id="element-310">
              $76.900
            </div>
            <div className="text-3xl md:text-4xl font-extrabold text-primary" data-id="element-311">
              $27.990{' '}
              <span className="text-base md:text-lg text-zinc-400" data-id="element-312">ARS</span>
            </div>
          </div>

          <Button href={URL_NEGOCIO} fullWidth className="py-3.5 text-base shadow-[0_0_25px_rgba(249,168,212,0.4)]" data-id="element-313">
            👉 QUIERO EL PLAN TOTAL
          </Button>
        </div>
      </div>
    </section>;
}